<form autocomplete="off" class="form" (submit)="onSubmit($event)">
  <div class="field is-narrow">
    <label class="label" translationEditableDirective="GIS_SERVER_URL">{{
      'GIS_SERVER_URL' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="gisServerUrl"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['gisServerUrl'])"
        [ngClass]="{ 'is-danger': hasError('gisServerUrl') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('gisServerUrl')">
      {{ getError('gisServerUrl') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="GIS_WORKSPACE">{{
      'GIS_WORKSPACE' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="gisWorkspace"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['gisWorkspace'])"
        [ngClass]="{ 'is-danger': hasError('gisWorkspace') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('gisWorkspace')">
      {{ getError('gisWorkspace') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="GIS_EXTENT">{{
      'GIS_EXTENT' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="gisExtent"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['gisExtent'])"
        [ngClass]="{ 'is-danger': hasError('gisExtent') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('gisExtent')">
      {{ getError('gisExtent') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="GIS_BASE_LAYER">{{
      'GIS_BASE_LAYER' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="gisBaseLayer"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['gisBaseLayer'])"
        [ngClass]="{ 'is-danger': hasError('gisBaseLayer') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('gisBaseLayer')">
      {{ getError('gisBaseLayer') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="GIS_POINT_LAYER">{{
      'GIS_POINT_LAYER' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="gisPointLayer"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['gisPointLayer'])"
        [ngClass]="{ 'is-danger': hasError('gisPointLayer') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('gisPointLayer')">
      {{ getError('gisPointLayer') }}
    </p>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-link"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </div>
</form>
